<template>
  <div>
    <Layout :pagetitle="$t('Lotto report')">
      <b-card>
        <b-row>
          <b-col class="m-2">
            <b-row>
              <b-col md="3">
                <label>{{ $t('Brand') }}</label>
                <brandSelectorUnique :modelValue="idBrand" @onChange="changeBrandFilter" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Sub Brand') }}</label>
                <subBrandsSelector
                  :mode="'single'"
                  :modelValue="idSubBrand"
                  @onChange="setSubBrand"
                  :allowEmpty="true"
                />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Product Type') }}</label>
                <productTypeSelector :modelValue="idProductType" @onChange="setProductType" :slug="'lotto'" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Affiliate') }} - Token</label>
                <b-form-input v-model="token" maxlength="6" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <!-- <b-col md="3">
                <label>{{ $t('Group By') }}</label>
                <generic-selector :customOptions="groupByOptions" :modelValue="groupBy" @onChange="setGroupBy" />
              </b-col> -->
              <b-col md="3">
                <label>{{ $t('Reward Profile') }}</label>
                <rewardProfileSelector :modelValue="idRewardProfile" @onChange="selectProfile" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Data Início') }}</label>
                <input class="form-control" type="date" v-model="startDate" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Data Fim') }}</label>
                <input class="form-control" type="date" v-model="endDate" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="8" />
              <b-col md="4">
                <div class="table-buttons">
                  <button class="btn btn-sm btn-success" :disabled="!reportData.length" @click="downloadXls">
                    {{ $t('XLS') }}
                  </button>
                  <button
                    class="ml-1 btn btn-sm btn-primary"
                    :disabled="!idBrand || !startDate || !endDate"
                    @click="getReport"
                  >
                    {{ $t('Buscar') }}
                  </button>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-if="reportData.length">
          <b-col class="">
            <div class="card my-0 py-0 border border-primary">
              <div class="card-header bg-transparent border-primary py-0">
                <h5 class="my-0 text-primary">
                  <i :class="`fas fa-ticket-alt me-3`"></i>
                  {{ $t('Summary') }}
                </h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Reward') }}
                    </span>
                    <span class="h5 text-center"> {{ $utils.formatMoneyFloat(reportTotal.entry_value) }} </span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Turnover') }}
                    </span>
                    <span class="h5 text-center"> {{ $utils.formatMoneyFloat(reportTotal.turnover) }} </span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Payout') }}
                    </span>
                    <span class="h5 text-center"> {{ $utils.formatMoneyFloat(reportTotal.payout) }} </span>
                  </div>
                  <div class="summary-column">
                    <span class="text-muted small d-block">
                      {{ $t('Bonus') }}
                    </span>
                    <span class="h5 text-center"> {{ $utils.formatMoneyFloat(reportTotal.bonus) }} </span>
                  </div>
                  <div class="summary-column" v-if="groupBy !== 'product_type'">
                    <span class="text-muted small d-block"> {{ $t('Qty') }}. {{ $t('Rewards') }} </span>
                    <span class="h5 text-center"> {{ totalItems }} </span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="reportData.length">
          <b-col class="d-flex justify-content-end mt-1">
            <small class="fs-minimum">
              <i :class="`fas fa-info me-3`" />
              {{ $t('Relatório com informativo de valor de comissões por produtos lotéricos') }}
            </small>
          </b-col>
        </b-row>

        <Table
          :title="''"
          :items="tableData"
          :columns="columns"
          :totalItems="totalItems"
          :showButtons="false"
          :searchable="false"
          :editable="false"
          :removable="false"
          :showPagination="true"
          :isCard="false"
          :customColumn="true"
          :customColumnLabel="$t('Games')"
          @customColumnClick="showGames"
          @onChangePage="changePage"
        />
      </b-card>
    </Layout>
    <b-modal v-model="gamesModal" :title="$t('Games')" size="lg" hide-footer>
      <Table
        :title="''"
        :items="games"
        :columns="columnsGames"
        :totalItems="games.length"
        :showButtons="false"
        :searchable="false"
        :editable="false"
        :removable="false"
        :showPagination="false"
        :isCard="false"
        :customColumn="false"
      />
    </b-modal>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import staticData from './staticData';
import { exportXls, groupedGames } from './functions';
import functions from './functions';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import moment from 'moment';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';
import productTypeSelector from '@/components/selectors/productTypeSelector.vue';
import rewardProfileSelector from '@/components/selectors/rewardProfileSelector.vue';

export default {
  components: {
    Layout,
    Table,
    brandSelectorUnique,
    subBrandsSelector,
    productTypeSelector,
    rewardProfileSelector
  },
  data() {
    return {
      idProductType: null,
      startDate: moment(moment().format('YYYY-MM')).subtract('months', 1).format('YYYY-MM-DD'),
      endDate: moment(moment().format('YYYY-MM')).subtract('days', 1).format('YYYY-MM-DD'),
      idBrand: null,
      token: '',
      idSubBrand: null,
      reportData: [],
      columnsGames: staticData().columnsGames,
      reportTotal: { turnover: 0, payout: 0, bonus: 0, entry_value: 0 },
      games: [],
      gamesModal: false,
      idRewardProfile: null,
      groupBy: 'select',
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      groupByOptions: [
        { value: 'select', label: this.$t('No') },
        { value: 'product_type', label: this.$t('Product Type') }
      ]
    };
  },
  created() {
    this.$nextTick(() => {
      this.idProductType = 2;
    });
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    showGames(item) {
      if (!item?.data?.length) {
        this.$customAlert({
          type: 'warning',
          msg: 'Informação não disponível'
        });
        return;
      }

      let data = this.$utils.getObjectRaw(item.data);

      if (item?.product_type_id_external) {
        data = data.filter((i) => `${i.gameId}` === `${item.product_type_id_external}`);
      }

      this.games = groupedGames(data);

      this.gamesModal = true;
    },
    selectProfile(reward_profile_id) {
      this.idRewardProfile = reward_profile_id;
    },
    setProductType(idProductType) {
      this.idProductType = idProductType;
    },
    setSubBrand(id = null) {
      this.idSubBrand = id;
    },
    getReport() {
      let payload = {
        idBrand: this.idBrand,
        startDate: this.startDate,
        endDate: this.endDate
      };

      if (this.idSubBrand) {
        payload['idSubBrand'] = this.idSubBrand;
      }

      if (this.idProductType) {
        payload['idProductType'] = this.idProductType;
      } else {
        this.$customAlert({
          msg: this.$t('Invalid product type'),
          type: 'warning'
        });
        return;
      }

      if (this.token) {
        payload['token'] = this.token;
      }

      if (this.idRewardProfile) {
        payload['idRewardProfile'] = this.idRewardProfile;
      }

      // diference between startDate and endDate not can be more than one month
      if (moment(this.endDate).diff(moment(this.startDate), 'days') > 31) {
        this.$customAlert({
          type: 'warning',
          msg: 'The difference between start date and end date must be less than one month'
        });
        return;
      }

      this.$store.commit('SET_LOADING', true);
      this.$api
        .get('api/lotteryReport', payload)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.reportData = this.loadReportData(res?.data || []);
          this.sumReport();
          this.totalItems = res?.data?.length;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    loadReportData(reportData = []) {
      reportData = reportData.map((i) => {
        let turnover = 0;
        let payout = 0;
        let bonus = 0;

        // Se for um jogo especifico, deve exibir turnover apenas desse game, não o total
        if (i?.product_type_id_external && i?.data?.length) {
          for (const game of i.data) {
            if (game.gameId === i.product_type_id_external) {
              turnover += parseFloat(game?.turnover || 0);
              payout += parseFloat(game?.payout || 0);
              bonus += parseFloat(game?.bonus || 0);
            }
          }
          // Se for comissão de lottery padrão, deve exibir o total normalmente
        } else {
          turnover = parseFloat(i?.turnover || 0);
          payout = parseFloat(i?.payout || 0);
          bonus = parseFloat(i?.bonus || 0);
        }

        return {
          ...i,
          transaction_date: i.transaction_date,
          turnover: turnover,
          payout: payout,
          bonus: bonus,
          reward_percentage: `${i.reward_percentage ? parseFloat(i.reward_percentage) * 100 : 0}%`
        };
      });

      return reportData;
    },
    changeBrandFilter(idBrand) {
      this.idBrand = idBrand;
    },
    setGroupBy(id) {
      this.groupBy = id;
    },
    sumReport() {
      this.reportTotal = {
        turnover: 0,
        payout: 0,
        bonus: 0,
        entry_value: 0,

        product_type_name: '',
        transaction_date: '',
        affiliate_name: '',
        affiliate_token: '',
        reward_percentage: ''
      };

      this.reportData.forEach((item) => {
        this.reportTotal.turnover += parseFloat(item.turnover);
        this.reportTotal.payout += parseFloat(item.payout);
        this.reportTotal.bonus += parseFloat(item.bonus);
        this.reportTotal.entry_value += parseFloat(item.entry_value);
      });
    },
    downloadXls() {
      exportXls([...this.reportData, this.reportTotal]);
    }
  },
  computed: {
    columns() {
      let cols = staticData().columns;

      if (this.groupBy === 'product_type') {
        cols = cols.filter((c) => {
          return c.key !== 'affiliate_name' && c.key !== 'transaction_date' && c.key !== 'affiliate_token';
        });
      }

      return cols;
    },
    tableData() {
      let data = functions.groupBy(this.reportData, this.groupBy);

      // paginate the data based on this.currentPage
      data = Array.from(data).slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);

      return data;
    }
  }
};
</script>

<style lang="scss">
.summary-column {
  white-space: nowrap !important;
  // min-width: 150px;
  flex: 1;
}

.summary-column-sm {
  min-width: 120px;
  flex: 1;
}

.summary-column-lg {
  min-width: 180px;
  flex: 1;
}
</style>
